export default __webpack_public_path__ + "static/media/MODALgarbanzo_EN.9eedb522.jpg";